
import { Options, Vue } from 'vue-class-component';
import * as OM from '@/model';
import store from '@/store';
import { StorageServices } from '@/services/StorageServices';
import {Prop} from 'vue-property-decorator';

@Options({})
export default class scratchAndWin extends Vue {

    @Prop() backgroundImage: string;
    @Prop() itemWonImage: string;

    base: HTMLDivElement = null;
    canvas: HTMLCanvasElement = null;
    context: CanvasRenderingContext2D = null;
    finished: boolean = false;
    isDrag: boolean = false;
    radius: number = 20;

    mounted(){
        this.base = this.$refs.base as HTMLDivElement;
        this.canvas = this.$refs.scratch as HTMLCanvasElement;
        this.canvas.width = this.base.clientWidth;
        this.canvas.height = this.base.clientHeight;
        
        this.context = this.canvas.getContext('2d', { willReadFrequently: true });

        this.context.globalCompositeOperation = 'source-over';

        const img = new Image();
        img.crossOrigin = 'anonymous';
        img.src = this.backgroundImage; // Inserisci qui l'URL della tua immagine

        img.onload = () => {
            this.context.drawImage(img, 0, 0, this.context.canvas.width, this.context.canvas.height);
        };

        // fill black
        // this.context.beginPath();
        // this.context.fillStyle = '#000000';
        // this.context.rect(0, 0, this.context.canvas.width, this.context.canvas.height);
        // this.context.fill();
    }

    clearArc(x, y, radius) {
        this.context.globalCompositeOperation = 'destination-out';
        this.context.beginPath();
        this.context.arc(x, y, radius, 0, Math.PI * 2, false);
        this.context.fill();
    }

    onMousedown(event) {
        if(this.finished) return;
        this.isDrag = true;
        this.clearArc(event.offsetX, event.offsetY, this.radius);
        if(this.judgeVisible()){
            this.finito();
        }
    }
    
    onMousemove(event) {
        if(this.finished) return;
        if (!this.isDrag) {
            return;
        }
        this.clearArc(event.offsetX, event.offsetY, this.radius);
        if(this.judgeVisible()){
            this.finito();
        }
    }

    onMouseup(event) {
        this.isDrag = false;
    }

    onMouseleave(event) {

    }
    
    touchFunction(event: TouchEvent){
        if (event.targetTouches.length !== 1) {
            return;
        }
        var bcr = this.canvas.getBoundingClientRect();
        var x = event.targetTouches[0].pageX - bcr.left;
        var y = event.targetTouches[0].pageY - bcr.top;
        this.clearArc(x, y, this.radius);
        
        if(this.judgeVisible()){
            this.finito();
        }
    }

    onTouchstart(event){
        if(this.finished) return;
        event.preventDefault();
        this.isDrag = true;
        this.touchFunction(event);
    }

    onTouchmove(event){
        if(this.finished) return;
        if (!this.isDrag || event.targetTouches.length !== 1) {
            return;
        }
        event.preventDefault();
        this.touchFunction(event);
    }

    onTouchend(event){
        this.isDrag = false;
    }

    judgeVisible() {
        var imageData = this.context.getImageData(
            0,
            // this.canvas.height * 0.10, 
            0,
            this.canvas.width,
            this.canvas.height
            // this.canvas.height * 0.60
        );
        var pixels = imageData.data;
        var result = {};
        var i = 3;
        var len = pixels.length;

        // count alpha values
        for (; i < len; i += 4) {
            result[pixels[i]] || (result[pixels[i]] = 0);
            result[pixels[i]]++;
        }

        let totalPixels = this.canvas.height * this.canvas.width;
        let enough = totalPixels * 0.8;
        return result[0] >= enough;
    }

    finito(){
        this.isDrag = false;
        this.finished = true;
        setTimeout(() => {
            this.$emit('finished');
        }, 2000)
    }
    
}
